import React from "react";
import { Table, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { fmtNum, fmtPct, pickLabel } from "./helpers";

export default function SummaryTable({ items, statusLabels }) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;

  const num = (v) => <span className="sch-num">{fmtNum(v, lng)}</span>;

  const columns = [
    {
      title: t("schools.colSchool"),
      dataIndex: "name",
      key: "name",
      width: 320,
      render: (name, r) => (
        <div className="sch-cell-school">
          <div>{name}</div>
          <div className="sub">{r.address}</div>
        </div>
      ),
    },
    {
      title: t("schools.colCap"),
      dataIndex: "capacity",
      key: "capacity",
      align: "right",
      width: 110,
      render: num,
    },
    {
      title: t("schools.colStudents"),
      dataIndex: "students",
      key: "students",
      align: "right",
      width: 110,
      render: num,
    },
    {
      title: (
        <Tooltip title={t("schools.loadHint")}>
          <span>{t("schools.colLoad")}</span>
        </Tooltip>
      ),
      dataIndex: "load_pct",
      key: "load_pct",
      align: "right",
      width: 130,
      render: (v) => <span className="sch-num">{fmtPct(v, lng)}</span>,
    },
    {
      title: t("schools.colDeficit"),
      dataIndex: "deficit",
      key: "deficit",
      align: "right",
      width: 120,
      render: num,
    },
    {
      title: t("schools.colTeachers"),
      dataIndex: "teachers",
      key: "teachers",
      align: "right",
      width: 100,
      render: num,
    },
    {
      title: t("schools.colShift"),
      dataIndex: "shift",
      key: "shift",
      width: 130,
      render: (_v, r) => pickLabel(r, lng, "shift_label"),
    },
    {
      title: t("schools.colLang"),
      dataIndex: "lang",
      key: "lang",
      width: 160,
      render: (_v, r) => pickLabel(r, lng, "lang_label"),
    },
    {
      title: t("schools.colStatus"),
      dataIndex: "status",
      key: "status",
      width: 190,
      render: (s) => (
        <span className="sch-status">
          <span className={`sch-dot ${s}`} />
          {statusLabels[s] || s}
        </span>
      ),
    },
  ];

  return (
    <Table
      className="sch-table"
      rowKey="id"
      columns={columns}
      dataSource={items}
      pagination={false}
      size="small"
      scroll={{ x: "max-content", y: 560 }}
    />
  );
}
